/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SegmentModel from 'cio/models/segment';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';

interface DataSourceLabelArgs {
  variant?: DataSourceLabelVariant;
  truncate?: boolean;
  segment?: SegmentModel;
  segmentId?: string;
  missingHint?: string;
}

/**
 * This component exists separately from `DataSourceLabel`, as combining the two
 * causes a circular reference somehow during the build outside of a dev env.
 *
 * Until we redesign the segment popover component, this needs to remain separate.
 */
export default class DataSourceLabelSegment extends Component<DataSourceLabelArgs> {
  get truncate() {
    return this.args.truncate ?? true;
  }

  get variant() {
    return this.args.variant ?? DataSourceLabelVariant.Dark;
  }

  get isMissing() {
    return this.args.segment == null && this.args.segmentId == null;
  }

  get variantClasses() {
    let classes = ['font-medium', 'inline-flex', 'items-center', 'gap-0.5', 'max-w-full'];

    if (this.variant === DataSourceLabelVariant.Unstyled) {
      return classes.join(' ');
    }

    classes.push(
      'fly-label',
      'fly-label--lg',
      'leading-[initial]',
      'border',
      'rounded',
      'transition-opacity',
      'border-gray-200',
      'text-base',
      'min-h-[30px]',
      'text-left',
      'break-all',
    );

    if (!this.truncate) {
      classes.push('whitespace-normal', 'overflow-auto');
    }

    if (this.variant === DataSourceLabelVariant.Light) {
      classes.push('bg-white');
    }

    if (this.variant === DataSourceLabelVariant.Dark) {
      classes.push('bg-gray-100');
    }

    return classes.join(' ');
  }
}
